/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, SAMPLE_TO_SALE_SCREEN, API_CONSTANTS } from '../../global/Constants';
import { HeaderTypes, ActivityType, ActivityStatusType, S2S_STAGE } from "../../global/Enum";
import './sample-to-sale.css';
import { toast } from 'react-toastify';
import Header from '../common/Header';
import ActivityHeader from '../common/ActivityHeader';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import SyncServices from '../../providers/SyncServices';
import SyncLoader from '../common/loader/SyncLoader';
import $ from 'jquery';
import AuthService from '../../providers/AuthService';


class SampleToSalePage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            activity: {},
            //currentStage: null,
            //currentStageId: [],
            showHarvestDetails: true,
            krishakInfo: null,
            harvestCount: 1
        }
    }

    componentDidMount() {
        toast.configure();
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {

                let activity = this.props.location.state.activity;
                Utilities.LogPrint("Data:-->", activity);

                // Added By krunal
                //activity.stage_id = 9;

                // For Pick Number
                let pickNo = 1;
                if (activity.activity_status_id === ActivityStatusType.TO_START && activity.stage_id === S2S_STAGE.HARVEST_DETAILS) {
                    pickNo = activity?.data?.history?.stage_five === undefined ? 1 : activity?.data?.history?.stage_five?.length + 1;
                } else {
                    pickNo = activity?.data?.history?.stage_five === undefined ? 1 : activity?.data?.history?.stage_five?.length;
                }

                this.setState({ activity: activity, harvestCount: pickNo });
                //this.setState({ activity: activity, harvestCount: activity?.stage?.params?.pick_no });

                // if (activity?.stage && activity?.stage != null) {
                //     const stage = activity?.stage;
                //     this.setState({
                //         currentStage: stage,
                //         currentStageId: stage?.stage_id
                //     })
                // }
                this.getKrishakById(activity.krishak_id);

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    getKrishakById = (krishak_id) => {
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                //Utilities.LogPrint("getKrishakFromDatabase", data);
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    const krishakInfo = data;
                    this.setState({
                        krishakInfo
                    });
                } else {
                    toast.info(COMMON.KRISHAK_NOT_FOUND);
                }
            } else {
                //Utilities.LogPrint("getKrishakFromDatabase", "no");
                toast.info(COMMON.KRISHAK_NOT_FOUND);
            }
        });

        // this.setState({ isLoading: true });
        // var body = JSON.stringify({
        //     krishak_id: krishak_id,
        // });
        // try {
        //     ApiServices.getKrishakById(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const krishakInfo = response.data;
        //             if (krishakInfo != null) {
        //                 this.setState({
        //                     krishakInfo,
        //                 })
        //             }
        //         } else {

        //         }
        //         this.setState({ isLoading: false });
        //     }).catch(error => {
        //         this.setState({ isLoading: false });
        //         //Utilities.LogPrint("getKrishakById", error);
        //     });
        // } catch (error) {
        //     this.setState({ isLoading: false });
        //     //Utilities.LogPrint("getKrishakById", error);
        // }
    }

    handleBack = () => {
        this.props.history.goBack();
    }

    viewActivityHistory = () => {
        const { activity, krishakInfo } = this.state;
        //this.props.history.push(ALL_ROUTES.ACTIVITY_HISTORY_ROUTE);

        let krishak = {
            farmerName: krishakInfo?.name,
            phone: krishakInfo?.phone
        }
        this.props.history.push({
            pathname: ALL_ROUTES.ACTIVITY_HISTORY_ROUTE,
            state: { activity: activity, krishakInfo: krishak }
        });
    }

    viewStageActivity = (stageType) => {
        const { activity } = this.state;

        switch (stageType) {
            case S2S_STAGE.SOWING:
                this.props.history.push({
                    pathname: ALL_ROUTES.SHOWING_TRANSPLANTATION_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.TRANSPLANTATION:
                this.props.history.push({
                    pathname: ALL_ROUTES.TRANSPLANTATION_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.PLOT_VISIT:
                this.props.history.push({
                    pathname: ALL_ROUTES.PLOT_VISIT_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.FIELD_DAY:
                this.props.history.push({
                    pathname: ALL_ROUTES.FIELD_DAY_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.HARVEST_DETAILS:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_HARVEST_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.FIELD_DAMAGE:
                this.props.history.push({
                    pathname: ALL_ROUTES.FIELD_DAMAGE_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.GERMINATION:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_GERMINATION_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.FRUIT_QUALITY:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_FRUIT_QUALITY_ROUTE,
                    state: { activity: activity }
                });
                break;

            case S2S_STAGE.PEST_AND_DISEASE:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_PEST_DISEASE_ROUTE,
                    state: { activity: activity }
                });
                break;

            default:
                break;
        }
    }

    handleDialogYesButton = () => {
        this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
    }

    handleCancelButton = () => {
        //this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
        //this.props.history.goBack();

        if (!this.isFormValid()) {
            $('#confirmPopup').trigger('click');
        } else {
            this.props.history.goBack();
        }
    }

    handleSubmitButton = () => {
        const { activity } = this.state;

        const stage = activity?.stage;
        const currentStageId = activity?.stage_id;

        this.addDataInLocal(activity);

        // If User Online
        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });

            const session = AuthService.getSession();
            const isTMLogin = session?.user.user_id === activity?.user_id ? true : false;
            const activityStatusId = isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW;

            const formData = new FormData();
            formData.append("activity_id", activity.activity_id);
            formData.append("stage_id", currentStageId);
            formData.append("activity_status_id", activityStatusId);

            if (activity?.stage_id === S2S_STAGE.SOWING) {

                const sowingStage = activity?.sowingStage;

                formData.append("sowing_date", sowingStage.sowing_date);
                //formData.append("transplantation_date", sowingStage.transplantation_date);
                formData.append("irrigation_source_id", sowingStage?.irrigation_source?.value);
                formData.append("sowing_spacing_id", sowingStage?.sowing_spacing?.value);
                formData.append("stage_remark", sowingStage?.remark);
                formData.append("latitude", sowingStage?.latitude);
                formData.append("longitude", sowingStage?.longitude);
                // For S2S Veg 
                formData.append("row_spacing", sowingStage?.row_spacing);
                formData.append("plant_spacing", sowingStage?.plant_spacing);

                for (var i = 0; i < sowingStage?.images.length; i++) {
                    const objImage = sowingStage?.images[i];
                    if (objImage.image_id === 0) {
                        formData.append("stage_image", objImage.file);
                    }
                }

                // For Deleted Images
                if (sowingStage?.deletedImages?.length > 0) {
                    SyncServices.deleteServerImages(sowingStage?.deletedImages);
                }

                Utilities.LogPrint("SowingStage", sowingStage);

            } else if (activity?.stage_id === S2S_STAGE.TRANSPLANTATION) {
                const transplantationStage = activity?.transplantationStage;

                formData.append("transplantation_date", transplantationStage.transplantation_date);
                formData.append("stage_remark", transplantationStage?.remark);
                formData.append("latitude", transplantationStage?.latitude);
                formData.append("longitude", transplantationStage?.longitude);

                // For S2S Veg 
                formData.append("row_spacing", transplantationStage?.row_spacing);
                formData.append("plant_spacing", transplantationStage?.plant_spacing);

                for (let i = 0; i < transplantationStage?.images.length; i++) {
                    const objImage = transplantationStage?.images[i];
                    if (objImage.image_id === 0) {
                        formData.append("stage_image", objImage.file);
                    }
                }

                // For Deleted Images
                if (transplantationStage?.deletedImages?.length > 0) {
                    SyncServices.deleteServerImages(transplantationStage?.deletedImages);
                }

            } else if (activity?.stage_id === S2S_STAGE.GERMINATION) {

                const germinationStage = activity?.germinationStage;
                Utilities.LogPrint("germinationStage", germinationStage);

                formData.append("germination", germinationStage.germination);
                formData.append("stage_remark", germinationStage?.remark);
                formData.append("latitude", germinationStage?.latitude);
                formData.append("longitude", germinationStage?.longitude);

                for (let i = 0; i < germinationStage?.images.length; i++) {
                    const objImage = germinationStage?.images[i];
                    if (objImage.image_id === 0) {
                        formData.append("stage_image", objImage.file);
                    }
                }

                // For Deleted Images
                if (germinationStage?.deletedImages?.length > 0) {
                    SyncServices.deleteServerImages(germinationStage?.deletedImages);
                }


            } else if (activity?.stage_id === S2S_STAGE.FRUIT_QUALITY) {

                const fruitQualityStage = activity?.fruitQualityStage;
                Utilities.LogPrint("FruitQualityStage", fruitQualityStage);

                let fruitQuality = {
                    fruit_uniformity: fruitQualityStage?.fruit_uniformity,
                    fruit_color: fruitQualityStage?.fruit_color,
                    fruit_length: fruitQualityStage?.fruit_length,
                    fruit_girth: fruitQualityStage?.fruit_girth,
                    fruit_weight: fruitQualityStage?.fruit_weight
                }
                formData.append("fruit_quality", JSON.stringify(fruitQuality));
                formData.append("stage_remark", fruitQualityStage?.remark);
                formData.append("latitude", fruitQualityStage?.latitude);
                formData.append("longitude", fruitQualityStage?.longitude);


                for (let i = 0; i < fruitQualityStage?.images.length; i++) {
                    const objImage = fruitQualityStage?.images[i];
                    if (objImage.image_id === 0) {
                        formData.append("stage_image", objImage.file);
                    }
                }

                // For Deleted Images
                if (fruitQualityStage?.deletedImages?.length > 0) {
                    SyncServices.deleteServerImages(fruitQualityStage?.deletedImages);
                }


            } else if (activity?.stage_id === S2S_STAGE.PEST_AND_DISEASE) {

                const pestDiseaseStage = activity?.pestDiseaseStage;
                Utilities.LogPrint("PestDiseaseStage", pestDiseaseStage);

                let pestDiseaseObj = {
                    viral_disease: pestDiseaseStage.viral_disease,
                    wilt: pestDiseaseStage.wilt,
                    blight: pestDiseaseStage.blight
                }
                formData.append("pest_disease", JSON.stringify(pestDiseaseObj));
                formData.append("stage_remark", pestDiseaseStage?.remark);
                formData.append("latitude", pestDiseaseStage?.latitude);
                formData.append("longitude", pestDiseaseStage?.longitude);

                for (let i = 0; i < pestDiseaseStage?.images.length; i++) {
                    const objImage = pestDiseaseStage?.images[i];
                    if (objImage.image_id === 0) {
                        formData.append("stage_image", objImage.file);
                    }
                }

                // For Deleted Images
                if (pestDiseaseObj?.deletedImages?.length > 0) {
                    SyncServices.deleteServerImages(pestDiseaseObj?.deletedImages);
                }

            } else if (activity?.stage_id === S2S_STAGE.PLOT_VISIT) {

                let plotVisit = activity?.plotVisit;
                Utilities.LogPrint("plotVisit", plotVisit);

                if (plotVisit !== undefined && plotVisit != null) {
                    let plotVisitObj = {
                        date: Utilities.getCurrentDate(),
                        crop_calendar_plot_visit_id: stage?.params?.crop_calendar_plot_visit_id,
                        crop_plot_visit_crop_health_id: plotVisit?.cropHealth.value,
                        crop_days_id: plotVisit?.stage.value,
                        //data_id: activity?.stage?.data_id
                    }
                    Utilities.LogPrint("PlotVisitObj: -> ", plotVisitObj);

                    formData.append("activity_plot_visits", JSON.stringify(plotVisitObj));
                    formData.append("stage_remark", plotVisit?.remark);
                    formData.append("latitude", plotVisit?.latitude);
                    formData.append("longitude", plotVisit?.longitude);

                    for (let i = 0; i < plotVisit?.images.length; i++) {
                        const objImage = plotVisit?.images[i];
                        if (objImage.image_id === 0) {
                            formData.append("stage_image", objImage.file);
                        }
                    }

                    // For Deleted Images
                    if (plotVisit?.deletedImages?.length > 0) {
                        SyncServices.deleteServerImages(plotVisit?.deletedImages);
                    }
                }


            } else if (activity?.stage_id === S2S_STAGE.FIELD_DAY) {
                let fieldDay = activity?.fieldDay;
                Utilities.LogPrint("Field Day", fieldDay);

                if (fieldDay !== undefined && fieldDay != null) {
                    const users = fieldDay?.selectedUsers.map(item => {
                        return item.value
                    });

                    const managers = fieldDay?.selectedManagers.map(item => {
                        return item.value
                    });

                    let retailers = [];
                    fieldDay?.selectedRetailers.forEach(element => {
                        let retailer = {
                            dealer_id: element.value,
                            commitment: element.commitment,
                            commitment_weight_id: 1
                        };
                        retailers.push(retailer);
                    });

                    let preraks = [];
                    fieldDay?.selectedPreraks.forEach(element => {
                        let prerak = {
                            prerak_id: element.value,
                            commitment: element.commitment,
                            commitment_weight_id: 1
                        };
                        preraks.push(prerak);
                    });

                    let fieldDayObj = {
                        field_day_attend_by: users,
                        field_day_manager: managers,
                        farmer_count: fieldDay.farmerCount,
                        farmer_commitment: fieldDay.farmersCommitment,
                        farmer_commitment_weight_id: 1,

                        field_day_farmer: fieldDay.farmerNumbers,
                        field_day_dealer: retailers,
                        field_day_prerak: preraks,

                        feedback_id: 1,
                        feedback: fieldDay?.feedback
                    }
                    Utilities.LogPrint("FieldDayObj:-", fieldDayObj);

                    //formData.append("stage_id", currentStageId);
                    formData.append("field_days", JSON.stringify(fieldDayObj));
                    formData.append("latitude", fieldDay?.latitude);
                    formData.append("longitude", fieldDay?.longitude);

                    for (let i = 0; i < fieldDay?.farmerNumberImages.length; i++) {
                        const objImage = fieldDay?.farmerNumberImages[i];
                        if (objImage.image_id === 0) {
                            formData.append("field_day_farmer_image", objImage.file);
                        }
                    }

                    for (let i = 0; i < fieldDay?.images.length; i++) {
                        const objImage = fieldDay?.images[i];
                        if (objImage.image_id === 0) {
                            formData.append("stage_image", objImage.file);
                        }
                    }

                    // For Deleted Images
                    if (fieldDay?.deletedImages?.length > 0) {
                        SyncServices.deleteServerImages(fieldDay?.deletedImages);
                    }
                }
            } else if (activity?.stage_id === S2S_STAGE.HARVEST_DETAILS) {
                const harvest = activity?.harvest;
                Utilities.LogPrint("Harvest", harvest);

                if (harvest !== undefined && harvest != null) {
                    const harvestObj = harvest?.harvestObj;
                    Utilities.LogPrint("harvestObj", harvestObj);

                    formData.append("harvests", JSON.stringify(harvestObj));
                    formData.append("latitude", harvest.latitude);
                    formData.append("longitude", harvest.longitude);
                    formData.append("stage_remark", harvest.remark);
                    //formData.append("stage_image", harvest.images);

                    for (let i = 0; i < harvest?.images.length; i++) {
                        const objImage = harvest?.images[i];
                        if (objImage.image_id === 0) {
                            formData.append("stage_image", objImage.file);
                        }
                    }

                    // For Deleted Images
                    if (harvest?.deletedImages?.length > 0) {
                        SyncServices.deleteServerImages(harvest?.deletedImages);
                    }
                }
            }

            if (activity?.fieldDamage) {
                let fieldDamage = activity?.fieldDamage;
                Utilities.LogPrint("Field Damage", fieldDamage);

                if (fieldDamage !== undefined && fieldDamage != null) {
                    let fieldDamageObj = {
                        field_damage: fieldDamage?.isDamaged,
                        field_damage_reason_id: fieldDamage?.field_damage_reason_id
                    }

                    //formData.append("stage_id", currentStageId);
                    formData.append("field_damage", JSON.stringify(fieldDamageObj));
                    formData.append("field_damage_remark", fieldDamage.remark);

                    for (let i = 0; i < fieldDamage?.images.length; i++) {
                        const objImage = fieldDamage?.images[i];
                        if (objImage.image_id === 0) {
                            formData.append("field_damage_image", objImage.file);
                        }
                    }
                }
            }

            try {
                ApiServices.storeSampleToSaleById(formData)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            //const data = response.data;
                            SyncServices.updateSyncStatus(activity?.key, "true");
                            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);

                        } else {
                            Utilities.LogPrint("Status", response.message);
                            toast.info(response.message);
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            //this.addDataInLocal(activity);
            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
        }
    }

    addDataInLocal(activity) {
        Utilities.LogPrint("Local Main Obj", activity);
        let history = activity?.data?.history;

        const stage = activity?.stage;
        //const currentStageId = activity?.stage_id;

        if (activity?.stage_id === S2S_STAGE.SOWING) {

            const sowingStage = activity?.sowingStage;

            let stage_one = [{
                sowing_date: sowingStage.sowing_date,
                transplantation_date: sowingStage.transplantation_date,
                irrigation_source_id: sowingStage?.irrigation_source?.value,
                irrigation_source_name: sowingStage?.irrigation_source?.label,
                sowing_spacing_id: sowingStage?.sowing_spacing?.value,
                sowing_spacing_name: sowingStage?.sowing_spacing?.label,
                remark: sowingStage?.remark,
                images: sowingStage?.images,
                latitude: sowingStage?.latitude,
                longitude: sowingStage?.longitude,
                deletedImages: sowingStage?.deletedImages,
                vc_sowing: {
                    row_spacing: sowingStage?.row_spacing,
                    plant_spacing: sowingStage?.plant_spacing
                }
            }]
            Utilities.LogPrint("Local SowingStage", stage_one);
            //history.stage_one = stage_one;
            history = {
                stage_one: stage_one
            }

        } else if (activity?.stage_id === S2S_STAGE.TRANSPLANTATION) {

            const transplantationStage = activity?.transplantationStage;

            let stage_two = [{
                transplantation_date: transplantationStage.transplantation_date,
                remark: transplantationStage?.remark,
                images: transplantationStage?.images,
                latitude: transplantationStage?.latitude,
                longitude: transplantationStage?.longitude,
                deletedImages: transplantationStage?.deletedImages,
                vc_transplantation: {
                    row_spacing: transplantationStage?.row_spacing,
                    plant_spacing: transplantationStage?.plant_spacing
                }
            }]

            Utilities.LogPrint("Local Transplantation Stage", stage_two);
            history.stage_two = stage_two;

        } else if (activity?.stage_id === S2S_STAGE.GERMINATION) {

            const germinationStage = activity?.germinationStage;
            Utilities.LogPrint("germinationStage", germinationStage);

            if (germinationStage !== undefined && germinationStage != null) {
                let stage_eight = [{
                    germination: germinationStage.germination,
                    remark: germinationStage?.remark,
                    images: germinationStage?.images,
                    latitude: germinationStage?.latitude,
                    longitude: germinationStage?.longitude,
                    deletedImages: germinationStage?.deletedImages,
                }]
                history.stage_eight = stage_eight;
            }


        } else if (activity?.stage_id === S2S_STAGE.FRUIT_QUALITY) {
            const fruitQualityStage = activity?.fruitQualityStage;
            Utilities.LogPrint("fruitQualityStage", fruitQualityStage);

            if (fruitQualityStage !== undefined && fruitQualityStage != null) {
                let stage_nine = [{
                    fruit_uniformity: fruitQualityStage?.fruit_uniformity,
                    fruit_color: fruitQualityStage?.fruit_color,
                    fruit_length: fruitQualityStage?.fruit_length,
                    fruit_girth: fruitQualityStage?.fruit_girth,
                    fruit_weight: fruitQualityStage?.fruit_weight,
                    remark: fruitQualityStage?.remark,
                    images: fruitQualityStage?.images,
                    latitude: fruitQualityStage?.latitude,
                    longitude: fruitQualityStage?.longitude,
                    deletedImages: fruitQualityStage?.deletedImages,
                }];
                history.stage_nine = stage_nine;
            }

        } else if (activity?.stage_id === S2S_STAGE.PEST_AND_DISEASE) {

            const pestDiseaseStage = activity?.pestDiseaseStage;
            Utilities.LogPrint("pestDiseaseStage", pestDiseaseStage);

            if (pestDiseaseStage !== undefined && pestDiseaseStage != null) {
                let stage_ten = [{
                    viral_disease: pestDiseaseStage.viral_disease,
                    wilt: pestDiseaseStage.wilt,
                    blight: pestDiseaseStage.blight,
                    remark: pestDiseaseStage?.remark,
                    images: pestDiseaseStage?.images,
                    latitude: pestDiseaseStage?.latitude,
                    longitude: pestDiseaseStage?.longitude,
                    deletedImages: pestDiseaseStage?.deletedImages,
                }];
                history.stage_ten = stage_ten;
            }



        } else if (activity?.stage_id === S2S_STAGE.PLOT_VISIT) {
            const plotVisit = activity?.plotVisit;

            if (plotVisit !== undefined && plotVisit != null) {
                let stage_three = [{
                    date: Utilities.getCurrentDate(),
                    crop_calendar_plot_visit_id: stage?.params?.crop_calendar_plot_visit_id,
                    crop_plot_visit_crop_health_id: plotVisit?.cropHealth.value,
                    crop_days_id: plotVisit?.stage.value,
                    remark: plotVisit?.remark,
                    images: plotVisit?.images,
                    latitude: plotVisit?.latitude,
                    longitude: plotVisit?.longitude,
                    deletedImages: plotVisit?.deletedImages,

                    crop_plot_visit_crop_health_title: plotVisit?.cropHealth.label,
                }]
                Utilities.LogPrint("Local PlotVisit Stage", stage_three);
                history.stage_three = stage_three;
            }

        } else if (activity?.stage_id === S2S_STAGE.FIELD_DAY) {
            let fieldDay = activity?.fieldDay;
            Utilities.LogPrint("Field Day", fieldDay);

            if (fieldDay !== undefined && fieldDay != null) {
                const users = fieldDay?.selectedUsers.map(item => {
                    return item.value
                });

                const managers = fieldDay?.selectedManagers.map(item => {
                    return item.value
                });

                let retailers = [];
                fieldDay?.selectedRetailers.forEach(element => {
                    let retailer = {
                        dealer_id: element.value,
                        commitment: element.commitment,
                        commitment_weight_id: 1
                    };
                    retailers.push(retailer);
                });

                let preraks = [];
                fieldDay?.selectedPreraks.forEach(element => {
                    let prerak = {
                        prerak_id: element.value,
                        commitment: element.commitment,
                        commitment_weight_id: 1
                    };
                    preraks.push(prerak);
                });

                let fieldDayObj = {
                    field_day_attend_by: users,
                    field_day_manager: managers,
                    farmer_count: fieldDay.farmerCount,
                    farmer_commitment: fieldDay.farmersCommitment,
                    farmer_commitment_weight_id: 1,

                    field_day_farmer: fieldDay.farmerNumbers,
                    field_day_dealer: retailers,
                    field_day_prerak: preraks,

                    feedback_id: 1,
                    feedback: fieldDay?.feedback
                }
                Utilities.LogPrint("FieldDayObj:-", fieldDayObj);

                // For Local View
                let field_day_manager_bies = [];
                fieldDay?.selectedManagers.forEach(element => {
                    let manager = {
                        field_day_manager_id: element.value,
                        field_day_manager_name: element.label
                    };
                    field_day_manager_bies.push(manager);
                });


                let field_day_dealers = [];
                fieldDay?.selectedRetailers.forEach(element => {
                    let retailer = {
                        dealer_id: element.value,
                        commitment: element.commitment,
                        field_day_dealer_name: element.name
                    };
                    field_day_dealers.push(retailer);
                });

                let field_day_preraks = [];
                fieldDay?.selectedPreraks.forEach(element => {
                    let prerak = {
                        prerak_id: element.value,
                        commitment: element.commitment,
                        field_day_prerak_name: element.name
                    };
                    field_day_preraks.push(prerak);
                });


                let field_day_farmers = [];
                fieldDay?.farmerNumbers.forEach(element => {
                    let obj = {
                        is_phone: 1,
                        phone_image: element.phone
                    };
                    field_day_farmers.push(obj);
                });
                fieldDay?.farmerNumberImages.forEach(element => {
                    let obj = {
                        is_phone: 0,
                        phone_image: element.image_url
                    };
                    field_day_farmers.push(obj);
                });

                let stage_four = [{
                    farmer_count: fieldDay.farmerCount,
                    farmer_commitment: fieldDay.farmersCommitment,
                    farmer_commitment_weight_id: 1,
                    feedback: fieldDay?.feedback,

                    field_day_manager_bies: field_day_manager_bies,
                    field_day_dealers: field_day_dealers,
                    field_day_preraks: field_day_preraks,
                    field_day_farmers: field_day_farmers,

                    images: fieldDay?.images,
                    farmerNumberImages: fieldDay?.farmerNumberImages,
                    latitude: fieldDay?.latitude,
                    longitude: fieldDay?.longitude,

                    fieldDayObj: JSON.stringify(fieldDayObj)
                }]

                history.stage_four = stage_four;

            }

        } else if (activity?.stage_id === S2S_STAGE.HARVEST_DETAILS) {
            const harvest = activity?.harvest;
            Utilities.LogPrint("Harvest", harvest);

            if (harvest !== undefined && harvest != null) {
                let harvestObj = harvest?.harvestObj;
                Utilities.LogPrint("harvestObj", harvestObj);

                let stage_five = [{
                    ...harvestObj,
                    images: harvest?.images,
                    remark: harvest.remark,
                    latitude: harvest.latitude,
                    longitude: harvest.longitude,

                    harvestObj: JSON.stringify(harvestObj)
                }]

                Utilities.LogPrint("Local Harvest Stage", stage_five);
                history.stage_five = stage_five;
            }
        }

        if (activity?.fieldDamage) {
            let fieldDamage = activity?.fieldDamage;
            //Utilities.LogPrint("Field Damage", fieldDamage);

            if (fieldDamage !== undefined && fieldDamage != null) {

                let stage_six = [{
                    field_damage: fieldDamage?.isDamaged,
                    field_damage_reason_id: fieldDamage?.field_damage_reason_id,
                    remark: fieldDamage?.remark,
                    images: fieldDamage?.images,

                    field_damage_title: fieldDamage?.field_damage_reason_id === 1 ? "Yes" : "No",
                    field_damage_reason: fieldDamage?.damageDueTo
                }]

                Utilities.LogPrint("Local FieldDamage Stage", stage_six);

                history.stage_six = stage_six;
                // history = {
                //     stage_five: stage_five
                // }
            }
        }

        Utilities.LogPrint("Local history", history);
        let data = {
            history: history
        }

        const session = AuthService.getSession();
        const isTMLogin = session?.user.user_id === activity?.user_id ? true : false;

        if (isTMLogin) {
            SyncServices.editActivityById(activity.key, ActivityStatusType.COMPLETED, data);
        } else {
            SyncServices.editActivityById(activity.key, ActivityStatusType.PENDING_REVIEW, data);
        }

        //SyncServices.editActivityById(activity.key, ActivityStatusType.PENDING_REVIEW, data);
        //this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
        //this.props.history.goBack();
    }

    isFormValid() {
        const { activity } = this.state;
        return !activity?.sowingStage && !activity?.transplantationStage && !activity?.plotVisit && !activity?.fieldDay && !activity?.harvest && !activity?.fieldDamage
            && !activity?.germinationStage && !activity?.fruitQualityStage && !activity?.pestDiseaseStage;
    }

    // showStage(stageId) {
    //     const { currentStageId } = this.state;
    //     if (currentStageId.length > 0) {
    //         //Utilities.LogPrint("KKKKKK", currentStageId);
    //         const Stage = currentStageId.find(item => item === stageId);
    //         Utilities.LogPrint("KRU", Stage);
    //     }
    // }

    // visibleStage(val) {
    //     return this.state.currentStageId?.some(item => item === val);
    // }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, activity, krishakInfo, harvestCount } = this.state;
        return (
            <div>
                <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <ActivityHeader
                                type={ActivityType.SAMPLE_TO_SALE}
                                code={activity?.activity_tag}
                                title={activity.activity_type_name}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />

                            {/* <div className="activity-info-box green-activity mb-3 text-white">
                                <span>S2S2771</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE}</h5>
                                <span>CROP, HYBRID | Village</span>
                            </div> */}
                        </div>
                        <div className="col-lg-8 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary w-25 mr-2 krishak-cancel-btn" onClick={this.handleBack}>Back</button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <form >
                                {/* individual visit farmer */}
                                <div className="sample-to-sale">
                                    <div className="row">
                                        <div className="col-lg-4 col-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" placeholder={krishakInfo?.name} disabled />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" value={`+91 ${krishakInfo?.phone}`} placeholder="" disabled />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Activity History */}
                                    {
                                        activity?.stage_id !== S2S_STAGE.SOWING_AND_TRANSPLANTATION ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewActivityHistory()}>
                                                {SAMPLE_TO_SALE_SCREEN.ACTIVITY_HISTORY} <i className="customic ic-activity-history ml-auto"></i>
                                            </a> : null
                                    }

                                    {/* Sowing */}
                                    {
                                        activity?.stage_id === S2S_STAGE.SOWING_AND_TRANSPLANTATION ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.SOWING_AND_TRANSPLANTATION)}>
                                                {SAMPLE_TO_SALE_SCREEN.SOWING} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Transplantation */}
                                    {
                                        activity?.stage_id === S2S_STAGE.TRANSPLANTATION ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.TRANSPLANTATION)}>
                                                {SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Plot Visit */}
                                    {
                                        activity?.stage_id === S2S_STAGE.PLOT_VISIT ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.PLOT_VISIT)}>
                                                {SAMPLE_TO_SALE_SCREEN.PLOT_VISIT} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }


                                    {/* Field Day */}
                                    {
                                        activity?.stage_id === S2S_STAGE.FIELD_DAY ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.FIELD_DAY)}>
                                                {SAMPLE_TO_SALE_SCREEN.FIELD_DAY} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Germination */}
                                    {
                                        activity?.stage_id === S2S_STAGE.GERMINATION ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.GERMINATION)}>
                                                {SAMPLE_TO_SALE_SCREEN.GERMINATION} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Fruit Quality */}
                                    {
                                        activity?.stage_id === S2S_STAGE.FRUIT_QUALITY ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.FRUIT_QUALITY)}>
                                                {SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Pest & Disease */}
                                    {
                                        activity?.stage_id === S2S_STAGE.PEST_AND_DISEASE ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.PEST_AND_DISEASE)}>
                                                {SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Harvest Details */}
                                    {
                                        activity?.stage_id === S2S_STAGE.HARVEST_DETAILS ?
                                            <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.HARVEST_DETAILS)}>
                                                {`Harvest ${harvestCount} Details`} <i className="customic ic-go-button ml-auto"></i>
                                            </a>
                                            : null
                                    }

                                    {/* Field Damage */}
                                    <a className="d-flex align-items-center font-weight-bold my-3" onClick={() => this.viewStageActivity(S2S_STAGE.FIELD_DAMAGE)}>
                                        {SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE} <i className="customic ic-go-button ml-auto"></i>
                                    </a>

                                </div>

                            </form>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button
                                className="btn btn-secondary w-50 mr-2 krishak-cancel-btn"
                                //data-toggle="modal"
                                //data-target="#SaveConfirm"
                                onClick={this.handleCancelButton}>
                                {COMMON.CANCEL}
                            </button>
                            <button
                                className="btn btn-primary w-50"
                                onClick={this.handleSubmitButton}
                                disabled={this.isFormValid()}>
                                {COMMON.SUBMIT}
                            </button>
                        </div>

                        {/* This Must be hidden */}
                        <button id="confirmPopup" type="button" data-toggle="modal" data-target="#SaveConfirm"
                            className="d-none">placeholder</button>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                {this.showConformPopup()}
            </div>
        )
    }

    showConformPopup = () => {
        return (
            <div className="modal fade bottom-drawer" id="SaveConfirm" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body my-4">

                            <p>Are you sure you want to leave? All saved data you have entered will be lost.</p>
                            <div className="d-flex grey-btn">
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close" onClick={this.handleDialogYesButton}>Yes</button>
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(SampleToSalePage);